// extracted by mini-css-extract-plugin
export var headerSkerjancLogo = "header-module--headerSkerjancLogo--HpvSr";
export var headerTitle = "header-module--headerTitle--Ab+Os";
export var textWhite = "header-module--textWhite--44G4F";